import { SVGProps } from "react";

export const IconCornerUpLeft = (props: SVGProps<SVGSVGElement>) => {
  const width = props.width ? props.width : 1.5;
  const color = props.color ? props.color : "#ffffff";
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="icon icon-tabler icon-tabler-corner-up-left"
      viewBox="0 0 24 24"
      strokeWidth={width}
      stroke={color}
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path stroke="none" d="M0 0h24v24H0z" fill="none" />
      <path d="M18 18v-6a3 3 0 0 0 -3 -3h-10l4 -4m0 8l-4 -4" />
    </svg>
  );
};
